const productTitle = document.querySelector('.product__title');
const pTagAfterTitle = productTitle.nextElementSibling;
const rows = document.querySelectorAll('table tr');
const thirdRowSecondTd = rows[2].querySelectorAll('td')[1];

let clarityVal = '';
const rowsTables = document.querySelectorAll("#collapsetab-one table tr");

rowsTables.forEach(rowval => {
  const firstCell = rowval.cells[0]?.textContent.trim();
  if (firstCell === "Clarity") {
    clarityVal = rowval.cells[1]?.textContent.trim();
  }
});


// Get the purity content from the third row
const purityContent = thirdRowSecondTd.textContent;

// Check if the product is silver
// You can adjust this check based on how silver is represented (e.g., product title, class, or data attribute)
const isSilver = productTitle.textContent.toLowerCase().includes('silver') || document.body.classList.contains('silver-product');

if (isSilver) {
  // If it's silver, update without "IGI Certified"

  if (clarityVal != '') {
  pTagAfterTitle.textContent = purityContent + " Purity | " + clarityVal;
  }else{
  pTagAfterTitle.textContent = purityContent + " Purity";
  }
} else {
  // Otherwise, include "IGI Certified"
  pTagAfterTitle.textContent = purityContent + " Purity | " + clarityVal + " | IGI Certified";
}
